import { SortDirectionEnum } from '../enums';

export class PaginationInterface {
  limit?: number;
  page?: number;
  sortDirection?: SortDirectionEnum;
  sortColumn?: string;
}
